import { useEffect, useState, useTransition } from 'react';

import { useFetch } from '@motorway/motorway-handshake-components';

import { APIResponseStatus } from 'Services/api.types';

import { useVehicleCollectionSub } from 'Containers/app/vehicleCollection/hooks/useVehicleCollectionSub';

import { useIsDealerDirect } from './useIsDealerDirect';

export const useIsDealerDirectHandshake = () => {
  const [isPending, setIsPending] = useState(true);
  const [handshakeDealer, setHandshakeDealer] = useState<boolean | null>(null);

  const vehicleCollectionStatus = useVehicleCollectionSub();
  const { getHandshakeEnabled } = useFetch();

  const [, startTransition] = useTransition();
  const { id: dealerId } = vehicleCollectionStatus?.offer?.closingBid?.dealer ?? {};

  const { offerStatus } = vehicleCollectionStatus ?? {};

  const OFFER_STATUS_SUCCESS = offerStatus === APIResponseStatus.SUCCESS;
  const OFFER_STATUS_ERROR = offerStatus === APIResponseStatus.ERROR;

  useEffect(() => {
    if (!dealerId) {
      return;
    }
    setIsPending(true);
    setHandshakeDealer(null);

    startTransition(async () => {
      const { data, success } = await getHandshakeEnabled(dealerId);

      if (success) {
        const { enabled } = (data ?? {}) as { enabled: boolean };
        setHandshakeDealer(enabled);
      }

      setIsPending(false);

      if (!success) {
        globalThis?.Sentry?.captureException?.(new Error('Failed to fetch handshake enabled'), {
          extra: {
            data,
            dealerId,
          },
          tags: {
            fetch: 'useIsDealerDirectHandshake',
          },
        });
      }
    });
  }, [dealerId, getHandshakeEnabled]);

  useEffect(() => {
    if (
      (OFFER_STATUS_SUCCESS && !dealerId)
      || OFFER_STATUS_ERROR
    ) {
      setHandshakeDealer(false);
      setIsPending(false);
    }
  }, [OFFER_STATUS_SUCCESS, OFFER_STATUS_ERROR, dealerId]);

  const isDealerDirect = useIsDealerDirect();

  return { handshakeDealer, isDealerDirect, isHandshakePending: isPending };
};
